(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

module.exports = {
	init: function init() {
		var _this = this;

		$(document).on('externalLink', function (event, theExternalLink, modalID, modalContent) {
			_this.handleModal(event, theExternalLink, modalID, modalContent);
		});
	},

	handleModal: function handleModal(event, theExternalLink, modalID) {
		var modalContent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

		// get href and target from the anchor tag
		var modalArgs = {
			linkTo: theExternalLink[0].href,
			target: theExternalLink[0].target || '',
			linkElement: theExternalLink[0]
		};

		// Check for the exit modal forced newtab flag
		var forcedNewtab = typeof window.wpData !== 'undefined' && typeof window.wpData.exitModalNewtab !== 'undefined' && window.wpData.exitModalNewtab == 1;

		// Instantiate the modal
		var $modalSelector = $('[data-remodal-id=' + modalID + ']');

		if ($modalSelector.length === 0) {
			return;
		}
		var modal = $modalSelector.remodal();

		var altContent = $modalSelector.data('altContent');

		// Replace the modal copy if set
		// Check if there is 
		if (modalContent && !altContent) {
			$modalSelector.find('.exitModalContent').html(modalContent);
		}

		// Removal any existing confirmation triggers...
		$(document).off('confirmation', '[data-remodal-id=' + modalID + ']');

		// And add our new trigger, with the information we've provided.
		$(document).on('confirmation', '[data-remodal-id=' + modalID + ']', modalArgs, function (event) {
			if (typeof dataLayer !== 'undefined') {
				dataLayer.push({
					'event': 'rtrc.modalYes',
					'gtm.element': event.data.linkElement
				});
			}
			// If we're targetting anything
			if (event.data.target !== '') {
				// Use window.open to link with target
				window.open(event.data.linkTo, event.data.target);
			} else {
				// Otherwise, jump to our href
				window.location = event.data.linkTo;
			}
		});

		// Now that we've set things up, open the modal
		modal.open();
	}
};

},{}],2:[function(require,module,exports){
'use strict';

module.exports = {
	init: function init() {
		setTimeout(function () {
			// add class to required label row
			var $required_label = $('.mktoForm .mktoHtmlText span:contains(*Required Field)');
			if ($required_label) {
				$required_label.closest('.mktoFormRow').addClass('required-label');
			}

			// remove interstitial from policy link
			var $terms_label = $('.mktoForm #LbloptInbranded');
			if ($terms_label) {
				$terms_label.children().addClass('js-noTriggerExitModal');
			}
		}, 1200);
	}
};

},{}],3:[function(require,module,exports){
'use strict';

module.exports = {
	init: function init() {
		var _this = this;

		if (document.querySelector('body').classList.contains('error404')) {
			return true;
		}
		this.isiTrigger = $('#isi_tray').offset().top;
		this.fullIsi = $('#full_isi');
		this.isiPadding = parseInt(this.fullIsi.css('padding-top'));

		$(window).scroll(function () {
			var pos = _this.fullIsi.position().top + _this.isiPadding - $(window).scrollTop();

			if (pos <= _this.isiTrigger) {
				$('#full_isi .isi').removeClass('hidden');
				$('#isi_tray .isi').addClass('hidden');
				$('#isi_tray').hide();
				$('#full_isi').addClass('relative');
			} else {
				$('#full_isi .isi').addClass('hidden');
				$('#isi_tray .isi').removeClass('hidden');
				$('#full_isi').removeClass('relative');
				$('#isi_tray').show();
			}
		});
	},

	openDrawer: function openDrawer() {
		$('html, body').animate({
			scrollTop: this.fullIsi.position().top
		}, 2000);
	},

	closeDrawer: function closeDrawer() {
		$('html, body').animate({
			scrollTop: 0
		}, 2000);
	}
};

},{}],4:[function(require,module,exports){
'use strict';

var ui = require('./ui');
var isi = require('./isi');
var exitModal = require('./exitModal');
var forms = require('./forms');
var remodal = require('remodal');
var Sticky = require('sticky-js');

var $ = window.jQuery;

$(document).ready(function () {
	exitModal.init();
	forms.init();
	ui.init();
	isi.init();

	if (document.body.classList.contains('isMobile')) {
		$(window).on('scroll', function () {
			if (typeof sticky === 'undefined') {
				var _sticky = new Sticky('#sub-mast');
			}
		});
	} else {
		var _sticky2 = new Sticky('#sub-mast');
	}

	// Moving cookie banner
	$('#cookie-notice').insertBefore('#page');

	$('#menu-trigger .humburder-menu').click(function (e) {
		e.preventDefault();
		$('#menu-trigger .humburder-menu').addClass('hide-menu');
		$('#menu-trigger .close-menu-icon').addClass('vissible');
		$('#page-tag, #menu-connect').fadeOut(450);

		$('#main-nav').show({
			direction: 'left'
		}, 1000);

		document.addEventListener('click', closeMenu, {
			once: true,
			capture: true
		});
	});

	$('#menu-trigger .close-menu-icon').click(closeMenu);

	function closeMenu() {
		$('#menu-trigger .humburder-menu').removeClass('hide-menu');
		$('#menu-trigger .close-menu-icon').removeClass('vissible');
		$('#page-tag, #menu-connect').fadeIn(450);

		$('#main-nav').hide({
			direction: 'right'
		}, 1000);
	}

	/**
  * this is deprecated as of now, but i don't trust that it's gonna
  * stay that way, so I'm gonna leave it here for now
  */
	$('#isiToggleOpen, a[href="#isi"]').on('click', function (e) {
		e.preventDefault();
		isi.openDrawer();
	});
	$('#isiToggleClosed').on('click', function (e) {
		e.preventDefault();
		isi.closeDrawer();
	});

	$(window).on('scroll', function () {
		var y = $(this).scrollTop();

		if (y > 40) {
			$("#page-tag").addClass("opacity-hidden-0");
		} else {
			$("#page-tag").removeClass("opacity-hidden-0");
		}
	});

	// specific video
	var vimeo = $('#vimeo')[0],
	    $fvimeo = $(vimeo);

	$fvimeo.on('ready', function () {
		$fvimeo.on('play', function () {
			$(vimeo).next('.poster').fadeOut();
		});
	});

	/**
  * Validate the subscribe form fields
  */
	$('body.stay-informed .infusion-submit').on('click', function (e) {
		e.preventDefault();
		var tgtForm = e.currentTarget.parentNode.closest('form');
		var fields = $(tgtForm).find('input');
		var errors = [];
		var emailRegexp = /\S+@\S+\.\S+/i;

		fields.each(function (index, input) {
			if (input.dataset.required === "true" && input.value == "") {
				errors.push($('label[for=' + input.name + ']').html().replace('<sup>*</sup>', ''));
				return;
			}
			if (input.hasAttribute('data-match')) {
				if (!emailRegexp.test(input.value)) {
					errors.push($('label[for=' + input.name + ']').html().replace('<sup>*</sup>', ''));
					return;
				}
			}
			if (input.hasAttribute('data-max') && input.value.length > input.dataset.max) {
				errors.push($('label[for=' + input.name + ']').html().replace('<sup>*</sup>', ''));
				return;
			}
		});

		if (errors.length > 0) {
			$('.invalidContent').html('<h2>Please correct errors in the following fields:</h2><ul>' + errors.join('<br>') + '</ul>');
			var modal = $('.validationModal').remodal();
			modal.open();
			return false;
		}

		tgtForm.submit();
	});
});

},{"./exitModal":1,"./forms":2,"./isi":3,"./ui":5,"remodal":"remodal","sticky-js":"sticky-js"}],5:[function(require,module,exports){
'use strict';

var _ = require('lodash');

module.exports = {
	/**
  * Use this for global UI events, calulations etc
  */
	init: function init() {
		var _this = this;

		// Set up some variables
		this.$window = $(window);
		this.$body = $('body');
		this.mobileMediaQuery = "( max-width: 767px )";
		this.tabletMediaQuery = "( max-width: 1023px )";
		this.isMobile = false;
		this.isTablet = false;
		this.tabletClass = 'isTablet';
		this.mobileClass = 'isMobile';
		this.touchInputClass = 'touchInput';
		this.freeze = false;
		this.scrollTop = 0;

		// Get the display size
		this.displaySize();
		// Detect touch y'all
		this.detectTouch();

		/** A debounced resize function */
		var debouncedResize = _.throttle(function () {
			_this.resize();
		}, 50);
		// call the debounced function on resize
		this.$window.resize(function () {
			debouncedResize();
		});

		/** A debounced scroll function */
		var debouncedScroll = _.throttle(function () {
			_this.scroll();
		}, 50);
		// call the debounced function on resize
		this.$window.scroll(function () {
			debouncedScroll();
		});
	},

	/**
  * Resize triggers go here, this should be debounced in init
  */
	resize: function resize() {
		// Detect if we've hit a display threshold (to/from destop/mobile) and detect the actual size
		this.displayDetection();
	},

	/**
  * Scroll triggers go here, this should be debounced in init
  */
	scroll: function scroll() {
		// Probably ISI and sticky header stuff, once we make those
	},

	/**
  * Detects a touch event and add a class to the body, used in conjunction with screen size
  * detection, we should be able to infer mobile devices
  * @author Rob Szpila <robert@arteric.com>
  */
	detectTouch: function detectTouch() {
		var _this2 = this;

		/** A touch event listener that removes itself */
		$(document).one('touchstart', function () {
			_this2.$body.addClass(_this2.touchInputClass);
		});
	},

	/**
  * Using handy matchMeda we can be super accurate in JS about media queries...horray for parity
  * called from displayDetection on resize
  * @author Rob Szpila <robert@arteric.com>
  */
	displaySize: function displaySize() {
		if (window.matchMedia(this.tabletMediaQuery).matches) {
			// We're totally not mobile...probably
			this.isMobile = false;
			this.$body.removeClass(this.mobileClass);
			// We're TABLET!
			this.isTablet = true;
			this.$body.addClass(this.tabletClass);
		}
		if (window.matchMedia(this.mobileMediaQuery).matches) {
			// We're totally not tablet...definitely
			this.isTablet = false;
			this.$body.removeClass(this.tabletClass);
			// We're mobile!
			this.isMobile = true;
			this.$body.addClass(this.mobileClass);
		}
		if (!window.matchMedia(this.mobileMediaQuery).matches && !window.matchMedia(this.tabletMediaQuery).matches) {
			// We're nothing
			this.isTablet = false;
			this.isMobile = false;
			this.$body.removeClass(this.mobileClass).removeClass(this.tabletClass);
		}
	},

	/**
  * Emit a thing when we cross display thresholds
  */
	displayDetection: function displayDetection() {
		// Before we determine our size now, were we a larger size before?
		var wasLargeView = !this.isTablet && !this.isMobile;

		// Get the display size
		this.displaySize();

		// If we just changed down to tablet or mobile, lets get the user to where they were
		if (wasLargeView && (this.isTablet || this.isMobile)) {
			// Let's emit an event, because this is handy
			$(document).trigger('sizedToMobile');
		}
		// If we just changed up, emit an event
		if (!wasLargeView && !this.isTablet && !this.isMobile) {
			$(document).trigger('sizedToDesktop');
		}
	},

	/**
  * Check if we're at tablet or lower and set the body to fixed and preserve scroll
  * @author Rob Szpila <robert@arteric.com>
  */
	freezeScroll: function freezeScroll() {
		this.scrollTop = $(window).scrollTop();
		this.$body.addClass('fixed');
		this.$body.css('top', this.scrollTop * -1);
	},

	/**
  * Check if the scroll is frozen and unfreeze
  * @author Rob Szpila <robert@arteric.com>
  */
	unFreezeScroll: function unFreezeScroll() {
		if (this.$body.hasClass('fixed')) {
			this.$body.removeClass('fixed');
			this.$body.css('top', 'auto');
			$(window).scrollTop(this.scrollTop);
		}
	}
};

},{"lodash":"lodash"}]},{},[4]);
